<template>
	<span>
		<span v-if="storageLocation.isActive === 'false'">
			<b-badge variant="secondary">Inactive</b-badge>
		</span>
		<span v-else>
			<b-badge variant="success">Active</b-badge>
		</span>
	</span>
</template>

<script>
export default {
	name: 'storage-location-status',
	props: {
		storageLocation: {
			type: Object,
			required: true
		}
	}
};
</script>

<style></style>